import styled from "styled-components";

export const GamesOpenSessionRecordHeaderDefaultBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 2px solid ${props => props.theme.colors.backgroundLight};
    padding: 4px;
    margin-bottom: 4px;
`